function createSchoolService(http) {
  const getByDomain = async (domain) => http.get(`/schools?domain=${domain}`);
  return {
    getByDomain,
  };
}

export default createSchoolService;
